import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './../../assets/css/materialdesignicons.css';


const Guests = () => {

  const [guests, setGuests] = useState([]);
  const tableRef = useRef(null)

 useEffect(() => {
    //fetch('http://localhost:5121/api/LoginRegistration/GetUsersByType?type=Guests')
    fetch('https://apiv2.chakran.in/api/LoginRegistration/GetUsersByType?type=Guests')
      .then((response) => response.json())
      .then((data) => {
        setGuests(data);
        // Add SrNo property to each record
        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1 // Add auto-incrementing SrNo
        }));
        console.log("Raw API Data:", data);
        if (tableRef.current) {
          $(tableRef.current).DataTable({
            data: data,
            columns: [
              { data: 'SrNo', title: 'Sr No' },
              { data: 'date', title: 'Date' },
              { data: 'cmsid', title: "CMSID" },
              { data: 'name', title: 'Name' },              
              { data: 'email', title: 'Email Id' },
              { data: 'number', title: 'Phone' },
              { data: 'address', title: 'Address' },
              {
                data: null,
                title: 'AadharCard',
                render: (data, type, row) => {
                  return `<button class='btn btn-sm btn-primary download-doc-btn' data-id='${row.id}' data-type='PdfAdhar'>Download</button>`;
                },
              },
              {
                data: null,
                title: 'PanCard',
                render: (data, type, row) => {
                  return `<button class='btn btn-sm btn-primary download-doc-btn' data-id='${row.id}' data-type='PdfPan'>Download</button>`;
                },
              },
              {
                data: null,
                title: 'Photo',
                render: (data, type, row) => {
                  return `<button class='btn btn-sm btn-primary download-doc-btn' data-id='${row.id}' data-type='Image'>Download</button>`;
                },
              },
            ],
          });
  
          // Event delegation for download buttons
          $('#productsTable tbody').on('click', '.download-doc-btn', function () {
            const userId = $(this).data('id');
            const fileType = $(this).data('type');
            downloadPDF(userId, fileType);
          });
        }
      });
  }, []);

  const downloadPDF = async (userId, type) => {
    try {
      const authToken = localStorage.getItem('authToken');
      //const endpoint = `http://localhost:5121/api/LoginRegistration/DownloadDocument/${userId}/${type}`;
      const endpoint = `https://apiv2.chakran.in/api/LoginRegistration/DownloadDocument/${userId}/${type}`;

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.status}`);
      }

      const blob = await response.blob();
      const contentType = response.headers.get('Content-Type');
      const fileExtension = contentType.split('/')[1] || 'pdf';

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Document_${type}.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download error:', error);
    }
  };
  return (
    <>
         <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Date</th>
            <th>CMS ID</th>
            <th>Name</th>
            <th>Email Id</th>
            <th>Phone</th>
            <th>Address</th>
          </tr>
        </thead>
    
      </table>
      </>
  );
}

export default Guests;

// import React, { useEffect, useRef } from 'react';
// import $ from 'jquery';
// import 'datatables.net-bs4';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './../../assets/css/materialdesignicons.css';

// const guestinitialData = [
//   { SrNo: 1, openingDate: "2011/04/25", name: "Tiger", emailId: "systemArchitect@gmail.com", phone: 9876543210, address: "fhufgfh jufdfdhf jhfdf jfffj", adharCard:"btn", panCard: "btn", photo: "btn"},
//   { SrNo: 2, openingDate: "2011/07/25", name: "Garrett", emailId: "accountant@gmail.com", phone: 8546973210, address: "nkdshf jn scjs hg gfsfb", adharCard: "btn", panCard: "btn", photo: "btn" },
//   { SrNo: 3, openingDate: "2011/04/25", name: "Nixon", emailId: "architectSystem@gmail.com", phone: 7845693210, address: "sji s ciscs cis ", adharCard: "btn", panCard: "btn", photo: "btn"},
//   { SrNo: 4, openingDate: "2011/07/25", name: "Winters", emailId: "accountant11@gmail.com", phone: 8965742310, address: "fj j jik if if if hfi", adharCard: "btn", panCard: "btn", photo: "btn"},
//   // ... add more data as needed
// ]

// const Guests = () => {
//   const tableRef = useRef(null)
//   useEffect(() => {
//     if (tableRef.current) {
//       const table = $(tableRef.current).DataTable({
//         data: guestinitialData,
//         columns: [
//           { data: 'SrNo', title: 'Sr No' },
//           { data: 'openingDate', title: 'Opening Date' },
//           { data: 'name', title: 'Name' },
//           { data: 'emailId', title: 'Email Id' },
//           { data: 'phone', title: 'phone' },
//           { data: 'address', title: 'Address' },
//           { data: 'adharCard', title: 'AdharCard',  render: (data, type, row) => {
//             return `
//             <div className="text-center">
//               <button className="btn btn-primary btn-pill text-center" data-id="${row.srNo}">
//                 Download
//               </button>
//               </div>
//             `;
//           } 
//         },
//         {data: 'panCard', title: 'PanCard',  render: (data, type, row) => {
//           return `
//           <div className="text-center">
//             <button className="btn btn-primary btn-pill text-center" data-id="${row.srNo}">
//               Download
//             </button>
//             </div>
//           `;
//         } 
//       },
//         {data: 'photo', title: 'Photo',  render: (data, type, row) => {
//           return `
//           <div className="text-center">
//             <button className="btn btn-primary btn-pill text-center" data-id="${row.srNo}">
//               Download
//             </button>
//           </div>
//           `;
//         } 
//       }
//         ],
//         initComplete: function () {
//           this.api().columns().each(function () {
//             const column = this
//             const select = $('<select className="form-control"><option value=""></option></select>')
//               .appendTo($(column.footer()).empty())
//               .on('change', function () {
//                 const val = $.fn.dataTable.util.escapeRegex(
//                   $(this).val()
//                 )

//                 column
//                   .search(val ? '^' + val + '$' : '', true, false)
//                   .draw()
//               })

//             column.data().unique().sort().each(function (d, j) {
//               select.append('<option value="' + d + '">' + d + '</option>')
//             })
//           })
//         }
//       })

//       return () => {
//         table.destroy()
//       }
//     }
//   }, [])

//   return (
//     <>
//          <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
//         <thead>
//           <tr>
//             <th>Sr No</th>
//             <th>Opeing Date</th>
//             <th>Name</th>
//             <th>Email Id</th>
//             <th>Phone</th>
//             <th>Address</th>
//           </tr>
//         </thead>
    
//       </table>
//       </>
//   );
// }

// export default Guests;